"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.NavigationHeaderV2 = void 0;
var _navigationHeaderV = _interopRequireDefault(require("./components/navigation-header-v2"));
exports.NavigationHeaderV2 = _navigationHeaderV["default"];